export default __webpack_public_path__ + "static/media/template6.313b6617.jpg";